export const CREATING_SYSTEM_USER = 'Creating User';
export const RETRIEVING_SYSTEM_USER = 'Retrieving User';
export const UPDATING_SYSTEM_USER = 'Updating User';
export const INITIATING_PASSWORD_RESET = 'Initiating Password Reset';
export const RESETTING_PASSWORD = 'Resetting Password';
export const DELETING_ACCOUNT = 'Deleting Account';
